import { DIGITAL_OCEAN_PATH, IMAGE_EXTENSION } from "constants/common";

export function isImageFile(fileName: string) {
  const lowerCaseFileName = fileName.toLowerCase();
  return IMAGE_EXTENSION.some((extension) =>
    lowerCaseFileName.endsWith(extension)
  );
}

export function getImageFullPath(url: string) {
  if (url.startsWith("http")) {
    return url;
  } else {
    return `${DIGITAL_OCEAN_PATH}/${url}`;
  }
}

export function isDigitalOceanImage(url: string) {
  if (url.startsWith("http")) {
    return false;
  } else {
    return true;
  }
}
